module.exports = __webpack_public_path__ + "media/src/images/user/default_avatars/default_avatar_8-3663e4e8baba0de8cd742b8eaee60c9e.png";